import Navbar from "../../../components/Navbar";
import Footer from "../../../components/Footer";
// import styles from "./Terms.module.css";
import styles from "../Privacy Policy/Privacy.module.css";
const Terms = () => {
  return (
    <>
      <Navbar />
      <div className={styles.container}>
        <div>
          <h4 className={styles.title}>Terms of Use</h4>

          <p className={styles.date}>Last Updated on 10th Nov, 2021</p>
        </div>
        <div className={styles.content}>
          <h6>
            Agreement between Woza Geleza, its sponsors and operators of this
            website (referred to as “Woza Geleza”, "us", "our" or "we" in these
            terms, which is an educational platform that houses a collection of
            learning materials and resources for students across South Africa)
            and the visitors to our website (referred to as "you" or "your" in
            these terms). In consideration of our making available this website
            for your use you accept the terms of this agreement by your use of
            this website. By using this website, you certify that you have read
            and reviewed this Agreement and that you agree to comply with its
            terms. If you do not want to be bound by the terms of this
            Agreement, you are advised to leave the website accordingly. Woza
            Geleza only grants use and access of this website to those who have
            accepted its terms.
          </h6>
          <h4>MODIFICATION OF THESE TERMS OF USE</h4>
          <h6>
            Woza Geleza reserves the right to change the terms, conditions, and
            notices under which the Web Site is offered, including but not
            limited to the charges associated with the use of the Web Site.
          </h6>
          <h4>LINKS TO THIRD PARTY SITES</h4>
          <h6>
            The web site contains links to other web sites ("Linked Sites"). The
            Linked Sites are not under the control of Woza Geleza and its
            operators are not responsible for the contents of any Linked Site,
            including without limitation any link contained in a Linked Site, or
            any changes or updates to a Linked Site. Woza Geleza is not
            responsible for webcasting or any other form of transmission
            received from any Linked Site. Woza Geleza is providing these links
            to you only as a convenience, and the inclusion of any link does not
            imply endorsement by Woza Geleza of the site or any association with
            its operators.
          </h6>
          <h4>NO UNLAWFUL OR PROHIBITED USE</h4>
          <h6>
            As a condition of your use of the Woza Geleza web site, you warrant
            that you will not use it for any purpose that is unlawful or
            prohibited by these terms, conditions, and notices. You may not use
            Woza Geleza web site in any manner which could damage, disable,
            overburden, or impair the web site or interfere with any other
            party's use and enjoyment of the Web Site. You may not obtain or
            attempt to obtain any materials or information through any means not
            intentionally made available or provided for through the Woza Geleza
            web site.
          </h6>
          <h4>USE OF COMMUNICATION SERVICES</h4>
          <h6>
            The Woza Geleza web site may contain bulletin board services, chat
            areas, news groups, forums, communities, personal web pages,
            calendars, and/or other message or communication facilities designed
            to enable you to communicate with the public at large or with a
            group (collectively, "Communication Services"), you agree to use the
            Communication Services only to post, send and receive messages and
            material that are proper and related to the particular Communication
            Service. By way of example, and not as a limitation, you agree that
            when using a Communication Service, you will not:
          </h6>
          <ul>
            <li>
              Defame, abuse, harass, stalk, threaten or otherwise violate the
              legal rights (such as rights of privacy and publicity) of others.
            </li>
            <li>
              Publish, post, upload, distribute or disseminate any
              inappropriate, profane, defamatory, infringing, obscene, indecent
              or unlawful topic, name, material or information.
            </li>
            <li>
              Upload files that contain software or other material protected by
              intellectual property laws (or by rights of privacy of publicity)
              unless you own or control the rights thereto or have received all
              necessary consents.
            </li>
            <li>
              Upload files that contain viruses, corrupted files, or any other
              similar software or programs that may damage the operation of
              another's computer.
            </li>
            <li>
              Advertise or offer to sell or buy any goods or services for any
              business purpose, unless such Communication Service specifically
              allows such messages.
            </li>
            <li>
              Conduct or forward surveys, contests, pyramid schemes or chain
              letters.
            </li>
            <li>
              Download any file posted by another user of a Communication
              Service that you know, or reasonably should know, cannot be
              legally distributed in such manner.
            </li>
            <li>
              Falsify or delete any author attributions, legal or other proper
              notices or proprietary designations or labels of the origin or
              source of software or other material contained in a file that is
              uploaded.
            </li>
            <li>
              Restrict or inhibit any other user from using and enjoying the
              Communication Services.
            </li>
            <li>
              Violate any code of conduct or other guidelines which may be
              applicable for any particular Communication Service.
            </li>
            <li>
              Harvest or otherwise collect information about others, including
              e-mail addresses, without their consent.
            </li>
            <li>Violate any applicable laws or regulations.</li>
          </ul>
          <h6>
            Woza Geleza has no obligation to monitor the Communication Services.
            However, Woza Geleza reserves the right to review materials posted
            to a Communication Service and to remove any materials in its sole
            discretion. Woza Geleza reserves the right to terminate your access
            to any or all of the Communication Services at any time without
            notice for any reason whatsoever.
          </h6>
          <h6>
            Woza Geleza reserves the right at all times to disclose any
            information as necessary to satisfy any applicable law, regulation,
            legal process or governmental request, or to edit, refuse to post or
            to remove any information or materials, in whole or in part, in
            their sole discretion.
          </h6>
          <h6>
            Always use caution when giving out any personally identifying
            information about yourself or minor children in any Communication
            Service. Woza Geleza does not control or endorse the content,
            messages or information found in any Communication Service and,
            therefore, Woza Geleza specifically disclaims any liability with
            regard to the Communication Services and any actions resulting from
            your participation in any Communication Service.
          </h6>
          <h6>
            Always use caution when giving out any personally identifying
            information about yourself or minor children in any Communication
            Service. Woza Geleza does not control or endorse the content,
            messages or information found in any Communication Service and,
            therefore, Woza Geleza specifically disclaims any liability with
            regard to the Communication Services and any actions resulting from
            your participation in any Communication Service.
          </h6>
          <h6>
            Materials uploaded to a Communication Service may be subject to
            posted limitations on usage, reproduction and/or dissemination. You
            are responsible for adhering to such limitations if you download the
            materials.
          </h6>
          <h4>
            MATERIALS PROVIDED TO WOZA GELEZA OR POSTED ON ANY WOZA GELEZA WEB
            SITE
          </h4>
          <h6>
            Woza Geleza does not claim ownership of the materials you provide
            (including feedback and suggestions) or post, upload, input or
            submit to any Woza Geleza web site or its associated services
            (collectively "Submissions"). However, by posting, uploading,
            inputting, providing or submitting your Submission you are granting
            Woza Geleza permission to use your Submission in connection with the
            operation of their Internet businesses including, without
            limitation, the rights to: copy, distribute, transmit, publicly
            display, publicly perform, reproduce, edit, translate and reformat
            your Submission; and to publish your name in connection with your
            Submission.
          </h6>
          <h6>
            No compensation will be paid with respect to the use of your
            Submission, as provided herein. Woza Geleza is under no obligation
            to post or use any Submission you may provide and may remove any
            Submission at any time in their sole discretion.
          </h6>
          <h6>
            By posting, uploading, inputting, providing or submitting your
            Submission you warrant and represent that you own or otherwise
            control all of the rights to your Submission as described in this
            section including, without limitation, all the rights necessary for
            you to provide, post, upload, input or submit the Submissions.
          </h6>
          <h4>COPYRIGHT AND USE OF MATERIAL</h4>
          <h6>
            We recognise that when you obtain access to our website, your
            computer downloads a copy of the material on this website. By
            obtaining access to our website, you agree that you will use the
            material for your personal use only, and not for any commercial
            purpose whatsoever. You are responsible for acting in compliance at
            all times with all applicable copyright laws. In particular you may
            not do any of the following without obtaining prior written
            permission from us:
          </h6>
          <ul>
            <li>
              Redistribute, modify, adapt or vary any of the content of our
              website.
            </li>
            <li>
              Remove any copyright or trademark notices from any copies of the
              content.
            </li>
            <li>
              Create a database in electronic or structured manual form by
              systematically downloading and storing all or any of the content
              of our website.
            </li>
          </ul>
          <h4>LIABILITY DISCLAIMER</h4>
          <h6>
            The information, software, products, and services included in or
            available through the Woza Geleza web site may include inaccuracies
            or typographical errors. Changes are periodically added to the
            information herein. Woza Geleza and/or its suppliers may make
            improvements and/or changes in the Woza Geleza web site at any time.
            Advice received via the Woza Geleza web site should not be relied
            upon for personal, medical, legal or financial decisions and you
            should consult an appropriate professional for specific advice
            tailored to your situation.
          </h6>
          <h6>
            Woza geleza and/or its suppliers make no representations about the
            suitability, reliability, availability, timeliness, and accuracy of
            the information, software, products, services and related graphics
            contained on the Woza Geleza web site for any purpose. To the
            maximum extent permitted by applicable law, all such information,
            software, products, services and related graphics are provided "as
            is" without warranty or condition of any kind. Woza Geleza and/or
            its suppliers hereby disclaim all warranties and conditions with
            regard to this information, software, products, services and related
            graphics, including all implied warranties or conditions of
            merchantability, fitness for a particular purpose, title and
            non-infringement.
          </h6>
          <h6>
            To the maximum extent permitted by applicable law, in no event shall
            Woza Geleza and/or its suppliers be liable for any direct, indirect,
            punitive, incidental, special, consequential damages or any damages
            whatsoever including, without limitation, damages for loss of use,
            data or profits, arising out of or in any way connected with the use
            or performance of the Woza Geleza web site, with the delay or
            inability to use the Woza Geleza web site or related services, the
            provision of or failure to provide services, or for any information,
            software, products, services and related graphics obtained through
            the Woza Geleza web site, or otherwise arising out of the use of the
            Woza Geleza web site, whether based on contract, tort, negligence,
            strict liability or otherwise, even if Woza Geleza or any of its
            suppliers has been advised of the possibility of damages. Because
            some states/jurisdictions do not allow the exclusion or limitation
            of liability for consequential or incidental damages, the above
            limitation may not apply to you. If you are dissatisfied with any
            portion of the Woza Geleza web site, or with any of these terms of
            use, your sole and exclusive remedy is to discontinue using the Woza
            Geleza web site.
          </h6>
          <h4>SERVICE CONTACT: AASAEducation@angloamerican.com </h4>
          <h4>INDEMNIFICATION</h4>
          <h6>
            You agree to indemnify Woza Geleza and its sponsors and hold Woza
            Geleza and its sponsors harmless against legal claims and demands
            that may arise from your use or misuse of our services.
          </h6>
          <h4>TERMINATION OF THIS AGREEMENT</h4>
          <h6>
            Woza Geleza reserves the right, in its sole and absolute discretion
            and without prior notification, to terminate the provision of this
            web site and/or to terminate the access rights of any user where,
            for example and without limitation:
          </h6>
          <ul>
            <li>
              Woza Geleza regards the action or inaction of a user to constitute
              a breach of these terms and conditions;
            </li>
            <li>
              Woza Geleza regards the action or inaction of a user to constitute
              abuse of the services offered through this web site.
            </li>
            <li>
              Events beyond the reasonable control of the website owner,
              including technical failures, prevent the continuing provision of
              the web site.
            </li>
          </ul>
          <h4>TRADEMARKS</h4>
          <h6>
            The names of actual companies and products mentioned herein may be
            the trademarks of their respective owners. Any and all rights not
            expressly granted herein are reserved.
          </h6>
          <h4>APPLICABLE LAW</h4>
          <h6>
            By visiting this website, you agree that the laws of the Republic of
            South Africa will govern these terms and conditions or any dispute
            of any sort that may arise.
          </h6>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Terms;
